<template>
  <!-- 底部 -->
  <div class="new-home-bottom">
    <div class="new-home-title">{{ $t("Home.homeSeachTitle") }}</div>
    <div class="new-home-bottom-card">
      <div class="new-home-card-left NewsBack">
        <img :src="ellipseImg" />
        <div
          class="slider-box"
          @click="goPage('https://www.csibizinfo.com/?Form=Csi')"
        >
          <div class="slider-con">
            <div
              class="slider-item"
              v-for="(item, index) in textList"
              :class="item.mk"
              :key="index"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="new-home-card-middle">
        <div
          class="new-home-middle-img"
          :style="{ backgroundImage: 'url(' + middleImg + ')' }"
        ></div>
        <div
          class="new-home-middle-text"
          @click="goPage('https://www.csibizinfo.com/')"
        >
          {{ $t("Home.homeTitleDetail") }}
        </div>
      </div>
      <div class="new-home-card-right">
        <div class="new-home-right-img">
          <img :src="wechatImg" />
        </div>
        <div class="new-home-right-text">
          {{ $t("Home.phoneTitleDetail") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    textList() {
      return [
        {
          title: this.$t("Home.BusinessIntelligence"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyIdentityVerification"),
          mk: "",
        },
        {
          title: this.$t("Home.KYCSolutions"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyFinancialAnalysis"),
          mk: "listhead",
        },
        {
          title: this.$t("Home.CreditRatings"),
          mk: "",
        },
        {
          title: this.$t("Home.CreditReports"),
          mk: "",
        },
        {
          title: this.$t("Home.ESGRatings"),
          mk: "",
        },
        {
          title: this.$t("Home.VendorScreening"),
          mk: "",
        },
        {
          title: this.$t("Home.MarketResearch"),
          mk: "",
        },
        {
          title: this.$t("Home.IndustryAnalysis"),
          mk: "",
        },
        {
          title: this.$t("Home.BusinessAnalytics"),
          mk: "",
        },
        {
          title: this.$t("Home.ImportExportData"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyNews"),
          mk: "",
        },
        {
          title: this.$t("Home.Sanctions"),
          mk: "",
        },
        {
          title: this.$t("Home.SearchLeads"),
          mk: "",
        },
        {
          title: this.$t("Home.BusinessIntelligence"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyIdentityVerification"),
          mk: "",
        },
        {
          title: this.$t("Home.KYCSolutions"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyFinancialAnalysis"),
          mk: "listhead2",
        },
        {
          title: this.$t("Home.CreditRatings"),
          mk: "",
        },
        {
          title: this.$t("Home.CreditReports"),
          mk: "",
        },
        {
          title: this.$t("Home.ESGRatings"),
          mk: "",
        },
        {
          title: this.$t("Home.VendorScreening"),
          mk: "",
        },
        {
          title: this.$t("Home.MarketResearch"),
          mk: "",
        },
        {
          title: this.$t("Home.IndustryAnalysis"),
          mk: "",
        },
        {
          title: this.$t("Home.BusinessAnalytics"),
          mk: "",
        },
        {
          title: this.$t("Home.ImportExportData"),
          mk: "",
        },
        {
          title: this.$t("Home.CompanyNews"),
          mk: "",
        },
        {
          title: this.$t("Home.Sanctions"),
          mk: "",
        },
        {
          title: this.$t("Home.SearchLeads"),
          mk: "",
        },
      ];
    },
  },
  data() {
    return {
      offest: 38,

      ellipseImg: require("@/assets/images/newPage/ellipse.png"),
      middleImg: require("@/assets/images/newPage/home-center.jpg"),
      wechatImg: require("@/assets/images/newPage/wechat.png"),
      initIndex: 3,
    };
  },
  methods: {
    goPage(value) {
      window.open(value, "_blank");
    },
    scrollInit() {
      if (document.body.clientWidth >= 1510) {
        this.offest = 38;
      } else {
        this.offest = 22;
      }
      const body = document.querySelector(".slider-box");
      if (body) {
        const bodyRect = body.getBoundingClientRect();

        const bodyCenterY = bodyRect.top + bodyRect.height / 2;
        document.querySelectorAll(".slider-item").forEach((li) => {
          const liRect = li.getBoundingClientRect();
          const liCenterY = liRect.top + liRect.height / 2 + this.offest;

          if (Math.abs(bodyCenterY - liCenterY) < liRect.height / 2) {
            li.classList.add("active");
            if (li.classList.contains("listhead2")) {
              const firstli = document.querySelector(".listhead");
              firstli.classList.add("active");
            }
          } else {
            li.classList.remove("active");
          }
        });
      }
    },
  },
  mounted() {
    setInterval(this.scrollInit, 100);
  },
  beforeDestroy() {
    clearInterval(this.scrollInit);
  },
};
</script>
<style scoped>
.new-home-con {
  flex: 1;
  position: relative;
}

.new-home-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: rgba(105, 128, 146, 0.45);
  border-radius: 6px;
  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  animation: scrollTop 30s linear infinite;
  will-change: transform;
}

@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-50%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  /* font-weight: bold; */
  font-size: 18px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s cubic-bezier(0, 1, 1, 1);
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 120%;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-43%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-57%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-size: 18px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-size: 18px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

@media (max-width: 1920px) {
  .new-home-title {
    width: calc(100% - 32px);
    height: 70px;
    line-height: 70px;
    padding-left: 16px;
    font-size: 28px;
    border-radius: 5px;
  }

  .new-home-bottom-card {
    height: 282px;
    padding: 16px;
    border-radius: 10px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 10px;
  }

  .new-home-card-left {
    padding-left: 40px;
  }

  .new-home-card-left img {
    top: 80px;
    left: 11px;
    width: 18px;
    height: 14px;
  }

  .new-home-card-left .slider-item {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-middle {
    margin: 0 12px;
  }

  .new-home-middle-img {
    width: 562px;
    height: 320px;
  }

  .new-home-middle-text {
    padding: 24px 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .new-home-card-right {
    width: 240px;
    padding: 32px 8px 0 8px;
    border-radius: 10px;
  }

  .new-home-right-img {
    width: 96px;
    height: 96px;
  }

  .new-home-right-text {
    font-size: 14px;
    line-height: 18px;
  }
}

.NewsBack {
  background-color: #009ea7 !important;
}
@media screen and (max-width: 1439px) {
  .new-home-title {
    width: calc(100% - 28px);
    height: 60px;
    line-height: 60px;
    padding-left: 14px;
    font-size: 24px;
    border-radius: 4px;
  }

  .new-home-bottom-card {
    height: 246px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 78px;
    left: 10px;
    width: 16px;
    height: 12px;
  }

  .new-home-card-left .slider-item {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 16px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 492px;
    height: 280px;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 16px;
  }

  .new-home-card-right {
    width: 210px;
    padding: 28px 10px 0 7px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 84px;
    height: 84px;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
